import React from 'react';
import { Provider as StoreProvider } from 'react-redux';
import get from 'lodash/get';
import { Route } from 'react-router-dom';

import { configureStore } from 'config/store';
import { bootStrapAccount } from 'bento-ordering/account/actions';
import BentoOrderingProviders from 'bento-ordering/context';
import App from 'bento-ordering/App';
import { PreviewModeDataContextProvider } from 'contexts/PreviewModeDataContext/index';

const store = configureStore();

if (get(window.bentoboxBaseOrdering, 'account')) {
  store.dispatch(bootStrapAccount());
}

const BentoOrderingApp = () => (
  <StoreProvider store={store}>
    <PreviewModeDataContextProvider>
      <BentoOrderingProviders>
        <Route render={props => <App {...props} />} />
      </BentoOrderingProviders>
    </PreviewModeDataContextProvider>
  </StoreProvider>
);

export default BentoOrderingApp;
